export interface Seller {
  id: string
  name: string
  isActive: boolean
  productCommissionPercentage: number
  freightCommissionPercentage: number
  categoryCommissionPercentage: number
  fulfillmentEndpoint: string | null
  sellerType: number
  isBetterScope: boolean
  logo: string | null
  email: string
  account: string | null
  storeName: string | null
  integration?: string
  isVtex?: boolean
}

export const createSellers = (count: number): Seller[] => {
  const integrations = [
    'vtex-seller',
    'vtex-sellerportal',
    'vtex-franchise',
    null,
  ]
  const sellers: Seller[] = []

  for (let i = 1; i <= count; i++) {
    const isVtex = i % 3 !== 0 // 2/3 dos sellers são VTEX
    const isActive = i % 5 !== 0 // 4/5 dos sellers estão ativos
    const isBetterScope = i % 4 === 0 // 1/4 dos sellers são betterScope
    const integrationIndex = i % 4

    sellers.push({
      id: String(i),
      name: `Seller ${i}`,
      isActive,
      productCommissionPercentage: 5 + (i % 16), // 5-20%
      freightCommissionPercentage: 2 + (i % 9), // 2-10%
      categoryCommissionPercentage: 3 + (i % 13), // 3-15%
      fulfillmentEndpoint: null,
      sellerType: 1, // Todos com sellerType: 1 como solicitado
      isBetterScope,
      logo: null,
      email: `seller${i}@example.com`,
      account: isVtex ? `account${i}` : null,
      storeName: isVtex ? `Store ${i}` : null,
      integration: integrations[integrationIndex] ?? undefined,
      isVtex,
    })
  }

  return sellers
}
